import React, { useState, useEffect } from "react";
import posed, { Transition } from "react-pose";
import "./style.scss";

const Box = posed.div({
  enter: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
});

function SplashScreen() {
  const [isShow, setView] = useState(false);
  useEffect(() => {
    setView(true);
  }, []);

  return (
    <Transition>
      {isShow && <Box className="SplashScreen" key="SplashScreen" />}
    </Transition>
  );
}

export default SplashScreen;
